import { CopyrightOutlined, HomeOutlined, LoginOutlined, SettingOutlined } from '@ant-design/icons';
import React, { ReactElement } from "react"
import About from 'src/Components/About';
import EmailVerify from 'src/Components/Account/EmailVerify';
import Login from 'src/Components/Account/Login';
import RegistrationForm from 'src/Components/Account/RegistrationForm';
import Gambler from 'src/Components/Gambler';
import GetData from 'src/Components/GetData';
import Home from 'src/Components/Home';
import Page404 from 'src/Components/Page404';
import PostData from 'src/Components/PostData';
import ShowMatch from 'src/Components/ShowMatch';
import AddTeam from 'src/Components/Team/AddTeam';

export interface IMenuItem {
    key: string,
    reactElement?: ReactElement,
    label: string,
    icon?: ReactElement,
    must_be_connected?: boolean,
    must_be_admin?: boolean,
    children?: IMenuItem[]
}

export const Page = {
    About: 'About',
    EmailVerify: 'EmailVerify',
    Registration: 'Registration',
    Login: 'Login',
    Create: 'Create',
    Merge: 'Merge',
    Delete: 'Delete',
    Administration: 'Administration',
    TestComposant: 'TestComposant',
    GetData: 'GetData',
    PostData: 'PostData',
    AddTeam: 'Administration/AddTeam',

}

const iconStyle = {
    fontSize: "inherit"
};

const menuItems: IMenuItem[] = [
    {
        label: "Connexion",
        key: Page.Login,
        icon: <LoginOutlined style={iconStyle}/>,
        reactElement: <Login/>,
        must_be_connected: false
    },
    {
        label: "Accueil",
        key: Page.Registration,
        icon: <HomeOutlined style={iconStyle}/>,
        reactElement: <RegistrationForm/>,
        must_be_connected: false
    },
    {
        label: "Test-Composant",
        key: Page.TestComposant,
        icon: <SettingOutlined style={iconStyle}/>,
        reactElement: <ShowMatch/>,
        must_be_connected: true,
        must_be_admin: false,
    },
    {
        label: "Administration",
        key: Page.Administration,
        icon: <SettingOutlined style={iconStyle}/>,
        // link: <LotCreator/>,
        must_be_connected: true,
        must_be_admin: true,
        children: [
            {
                label: "AddTeam",
                key: Page.AddTeam,
                reactElement: <AddTeam/>,
                children: [
                    {
                        label: "AddTeam",
                        key: Page.AddTeam,
                        reactElement: <AddTeam/>,
                    }
                ]
            },
            {
                label: "Submenu Item 2",
                key: "submenu2",
                reactElement: <Page404/>,
            },
            {
                label: "Parieurs",
                key: "Gamblers",
                reactElement: <Gambler/>,
            },
        ],
    },
    {
        label: "Get-Data",
        key: Page.GetData,
        icon: <SettingOutlined style={iconStyle}/>,
        reactElement: <GetData/>,
        must_be_connected: false,
        must_be_admin: false,
    },
    {
        label: "Post-Data",
        key: Page.PostData,
        icon: <SettingOutlined style={iconStyle}/>,
        reactElement: <PostData/>,
        must_be_connected: false,
        must_be_admin: false,
    },
    {
        label: "A Propos",
        key: Page.About,
        icon: <CopyrightOutlined style={iconStyle}/>,
        reactElement: <About/>,
        must_be_connected: false
    },
]

export default menuItems;

export interface IRoute {
    key?: string;
    reactElement?: React.ReactElement;
}

function extractRoutes(menuItems: IMenuItem[]): IRoute[] {
    const elements: IRoute[] = [];

    for (const menuItem of menuItems) {
        const newElement: IRoute = {
            key: menuItem.key,
            reactElement: menuItem.reactElement
        }
        elements.push(newElement);

        if (menuItem.children) {
            const childElements = extractRoutes(menuItem.children);
            elements.push(...childElements);
        }
    }

    return elements;
}

// Routes non accessibles via Menu !
const routes: IRoute[] = [
    {
        key: 'Home',
        reactElement: <Home/>
    },
    {
        key: '/account/EmailVerify',
        reactElement: <EmailVerify/>
    }
]
const routesFromMenuItems: IRoute[] = extractRoutes(menuItems);
export const theRoutes: IRoute[] = [ ...routes, ...routesFromMenuItems ];
